import React from 'react';
import {CheckBoxSelector, DropdownSelector } from 'hyperdb-utils';

const ZonesAreasSelector = (props) => {
  const countryOptions = () => {
    if (!props.countries) return [];
    return props.countries.map(c => ({ name: (c.name.$i18n || {})[props.defaultLanguage], value: c.id }));
  };
  const zoneOptions = () => {
    if (!props.zones) return [];
    return props.zones.map(z => ({ name: (z.name.$i18n || {})[props.defaultLanguage], value: z.id }));
  };
  const areasOptions = () => {
    if (!props.objectData.zone || !props.areas) return [];
    return props.areas.map(a => ({ name: (a.name.$i18n || {})[props.defaultLanguage], value: a.id }));
  };
  const mainAreaOptions = () => {
    if (!props.objectData.areas || !props.areas) return [];
    const selectedAreas = props.objectData.areas.filter(a => !a.deleted);
    const areasIds = selectedAreas.map(area => area.value[1]);
    return props.areas
      .filter(a => areasIds.indexOf(a.id) !== -1) // get selected areas
      .map(a => ({ name: (a.name.$i18n || {})[props.defaultLanguage], value: a.id }));
  };
  const listReferences = (references) => {
    return references.filter(a => !a.deleted).map(r => r.value[1]);
  };
  const handleSelectAreas = (field) => {
    const ids = field.value;
    // Change main_area depending of selected areas
    let mainAreaId = props.objectData.main_area.value[1];
    if (ids.length === 0) { // no area selected
      mainAreaId = null;
    } else if (ids.length === 1) { // first area is main_area
      mainAreaId = ids[0];
    } else {
      if (ids.indexOf(mainAreaId) === -1) { // main_area isn't selected anymore
        mainAreaId = ids[0];
      }
    }
    const references = ids.map(id => {
      return { $type: 'reference', external: true, value: ['areas', id] };
    });
    const deletedReferences = props.objectData.areas
      .filter(area => ids.indexOf(area.value[1]) === -1)
      .map(area => ({ ...area, deleted: true }));
    props.onChange('areas', { value: references.concat(deletedReferences) });
    props.onChange('main_area', { name: 'main_area', value: mainAreaId });
  };

  return (
    <div>
      <DropdownSelector
        label="Country *"
        name="country"
        value={ props.objectData.country.value[1] || '' }
        placeholder="-- select a country --"
        options={ countryOptions() }
        onChange={ props.onChange.bind(null, 'country') }
      />
    { props.objectData.country.value[1] && props.zones && props.zones.length ? (
      <DropdownSelector
        label="Zone *"
        name="zone"
        value={ props.objectData.zone.value[1] || '' }
        placeholder="-- select a zone --"
        options={ zoneOptions() }
        onChange={ props.onChange.bind(null, 'zone') }
      />
    ) : null }
    { props.objectData.zone.value[1] && props.areas && props.areas.length ? (
      <CheckBoxSelector
        label="Areas *"
        name="areas"
        value={ listReferences(props.objectData.areas || []) }
        options={ areasOptions() }
        onChange={ handleSelectAreas }
      />
    ) : null}
    { props.objectData.areas && props.objectData.areas.length ? (
      <DropdownSelector
        label="Main area *"
        name="main_area"
        value={ props.objectData.main_area.value[1] || '' }
        placeholder="-- select the main area --"
        options={ mainAreaOptions() }
        onChange={ props.onChange.bind(null, 'main_area') }
      />
    ) : null}
    </div>
  );
};

ZonesAreasSelector.propTypes = {
  objectData: React.PropTypes.object,
  countries: React.PropTypes.array,
  zones: React.PropTypes.array,
  areas: React.PropTypes.array,
  defaultLanguage: React.PropTypes.string,
  onChange: React.PropTypes.func,
};

export default ZonesAreasSelector;



// WEBPACK FOOTER //
// ./src/frontend/modules/inventory/property/components/PropertyEditor/ZonesAreasSelector.jsx